import { Link, Outlet } from "react-router-dom";

/**
 * Isolated chrome for god-mode onboarding — never shares company nav.
 * plan/18-admin-and-superadmin.md + plan/35
 */
export function SuperadminShell() {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="sticky top-0 z-10 border-b border-[var(--color-border)]/70 bg-[var(--color-shell)] backdrop-blur-xl supports-[padding:max(0px)]:pt-[max(0.65rem,env(safe-area-inset-top))]">
        <div className="mx-auto flex w-full max-w-[var(--desk-narrow-max)] items-center justify-between gap-4 px-4 py-3.5">
          <div className="min-w-0">
            <span className="block font-[family-name:var(--font-display)] text-xl font-semibold tracking-tight text-[var(--color-foreground)]">
              iCraftX
            </span>
            <span className="mt-0.5 block text-sm text-[var(--color-muted)]">
              Platform
            </span>
          </div>
          <nav className="flex items-center gap-0.5 text-sm">
            <Link
              to="/select-company"
              className="rounded-md px-2.5 py-2 text-[var(--color-muted)] no-underline transition-colors hover:bg-[var(--color-border)]/35 hover:text-[var(--color-foreground)]"
            >
              Exit
            </Link>
          </nav>
        </div>
      </header>
      <main
        className="mx-auto w-full max-w-[var(--desk-narrow-max)] flex-1 px-4 animate-[fadeIn_280ms_ease-out]"
        style={{
          paddingTop: "var(--desk-page-y)",
          paddingBottom: "max(2.5rem, env(safe-area-inset-bottom))",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}
